import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { selectProjectState } from "@org-avp/avp-avengers-ui-shared-store";
import { stringifyProjectName } from "@org-avp/avp-avengers-ui-shared-utils";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const useTitle = () => {
  const { t } = useTranslation();

  const { currentProject, currentSubproject } = useSelector(selectProjectState);

  const envTitle = useMemo(() => environment.NX_ENV_NAME !== "PROD" ? `[${environment.NX_ENV_NAME}] ` : "", []);

  const mainTitle = useMemo(
    () => !currentProject || !currentSubproject
      ? t("app:titleBar.appName")
      : `${stringifyProjectName(currentProject.name)} - ${currentSubproject.name}`,
    [currentProject, currentSubproject, t],
  );

  const title = useMemo(() => `${envTitle}${mainTitle} (${t("app:titleBar.confidential")})`, [envTitle, mainTitle, t]);

  useEffect(() => {
    document.title = title;
  }, [title]);

  return title;
};
